import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const CategoryMaster = lazy(
  () => import("@/pages/CategoryMaster/CategoryMaster"),
);

const ProductMaster = lazy(() => import("@/pages/ProductMaster/ProductMaster"));

const ChildProductMaster = lazy(
  () => import("@/pages/ProductMaster/ChildProductMaster"),
);

const BulkUploadCategory = lazy(
  () => import("@/pages/CategoryMaster/components/BulkUploadCategory"),
);
const CategoryMasterReport = lazy(
  () => import("@/pages/CategoryMaster/components/CategoryMasterReport"),
);
const ProductMasterReport = lazy(
  () => import("@/pages/ProductMaster/components/ProductMasterReport"),
);

const ViewCategories = lazy(
  () => import("@/pages/CategoryMaster/components/ViewCategory"),
);

const ViewProducts = lazy(
  () => import("@/pages/ProductMaster/components/ViewProduct"),
);

const BulkUploadProduct = lazy(
  () => import("@/pages/ProductMaster/components/BulkUploadProduct"),
);

const ProductCatalogueRoute: RouteConfig = {
  path: "",
  pageName: "Product Catalogue",
  permission: ["CatalogueView"],
  children: {
    Category_Master: {
      path: "categorymaster",
      element: <CategoryMaster />,
      pageName: "Category Master",
      sidebar: { show: true },
    },
    Bulk_Upload_Category: {
      path: "categorymaster/bulkUploadCategory",
      element: <BulkUploadCategory />,
      pageName: "Bulk Upload Category",
      sidebar: { show: false },
    },
    Category_Master_Report: {
      path: "categorymaster/report",
      element: <CategoryMasterReport />,
      pageName: "Category Master Report",
      sidebar: { show: false },
    },
    View_Categories: {
      path: "categorymaster/view/:FileId",
      element: <ViewCategories />,
      pageName: "View Categories",
      sidebar: { show: false },
    },
    Product_Master: {
      path: "productmaster",
      element: <ProductMaster />,
      pageName: "Product Master",
      sidebar: { show: true },
    },
    Bulk_Upload_Product: {
      path: "productmaster/bulkUploadProduct",
      element: <BulkUploadProduct />,
      pageName: "Bulk Upload Product",
      sidebar: { show: false },
    },
    Product_Master_Report: {
      path: "productmaster/report",
      element: <ProductMasterReport />,
      pageName: "Product Master Report",
      sidebar: { show: false },
    },
    View_Products: {
      path: "productmaster/view/:FileId",
      element: <ViewProducts />,
      pageName: "View Products",
      sidebar: { show: false },
    },
    Child_Product_Master: {
      path: "productmaster/productchild/:MasterProductId",
      element: <ChildProductMaster />,
      pageName: "Product Master",
      sidebar: { show: false },
    },
  },
};

export default ProductCatalogueRoute;
